import { render } from "./TerminalPage.vue?vue&type=template&id=2fb95b0d&scoped=true"
import script from "./TerminalPage.vue?vue&type=script&lang=js"
export * from "./TerminalPage.vue?vue&type=script&lang=js"

import "./TerminalPage.vue?vue&type=style&index=0&id=2fb95b0d&lang=css"
import "./TerminalPage.vue?vue&type=style&index=1&id=2fb95b0d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb95b0d"]])

export default __exports__